import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import displayPageServices from '../displayPageServices';
import DisplayWithWaitingList from '../components/DisplayWithWaitingList';

import AnnounceToken from '../components/AnnounceToken';
import DisplayCurrentToken from '../components/DisplayCurrentToken';
import DisplayVideoAdsOnly from '../components/DisplayVideoAdsOnly';
import DisplayBannersAdsAndNews from '../components/DisplayBannersAdsAndNews';
import MiniDisplay from '../components/MiniDisplay';
import DualCounterDisplay from '../components/DualCounterDisplay';
import MultipleDisplay from '../components/MultipleDisplay';
import { useMqtt } from '../../../context/MqttContext';



function DisplayPage() {
    const {displayType} = useParams();
    
    const {newMessage} = useMqtt();

    const [displayList,setDisplayList] = useState(null);
    const [displayInfo,setDisplayInfo] = useState(null);

    const getCheckinDisplayList = () => {
        if(displayType ==='waiting-list' || displayType ==='current-token' ){
            displayPageServices.getCheckinDisplayList().then(res=>{
                setDisplayList(res.data);
            }).catch(error=>{
            })
        }
        
    }

    const getCheckinDisplayInfo = () => {
        displayPageServices.getCheckinDisplayInfo().then(res=>{
            setDisplayInfo(res.data);
        }).catch(error=>{
        })
    }
    useEffect(()=>{
        getCheckinDisplayList();
        getCheckinDisplayInfo();
    },[])

    

    const [midSpeech,setMidSpeech] = useState("");
    const [postSpeech,setPostSpeech] = useState("");
    const getSpeechConfig = () =>{
        console.log("getting Speach config")
        let _midSpeech = localStorage.getItem("midSpeech");
        let _postSpeech = localStorage.getItem("postSpeech");
        localStorage.setItem("midSpeech",_midSpeech||"")
        localStorage.setItem("postSpeech",_postSpeech||"")
        setMidSpeech(_midSpeech||"")
        setPostSpeech(_postSpeech||" से संपर्क करे")
    }
    useEffect(()=>{
        getSpeechConfig();
    },[])




    const base64ToUrl = (b64Data, contentType = 'audio/mp3') => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        // Break the data into chunks for efficiency, especially for large files
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        // Create a Blob from the array of chunks
        const blob = new Blob(byteArrays, { type: contentType });
        // Create a URL representing the Blob data
        return URL.createObjectURL(blob);
    }
    
    const [announceTokenId,setAnnounceTokenId] = useState(0);

    useEffect(()=>{
        if(newMessage!== null){
            const {event,data} = newMessage;
            if(event === "announcement"){
                setAnnounceTokenId(data)
            }
            if(event == "voiceNote"){
                let audio1 = new Audio(base64ToUrl(data))
                audio1.play();
            }
            getCheckinDisplayList();
        }
        console.log(newMessage);
    },[newMessage])
    

    return (
        <>
            { /* sessionStorage.getItem('voiceIndex') !== null && <AnnounceToken announceToken={announceTokenId} />  */}
            { (displayType ==='waiting-list' || displayType ==='current-token' || displayType==='multiple-display') &&
                
                <AnnounceToken announceToken={announceTokenId} midSpeech={midSpeech} postSpeech={postSpeech} /> 
            }
            {displayType==='waiting-list' && displayInfo && displayList && <DisplayWithWaitingList displayList={displayList}  displayInfo={displayInfo} /> }
            {displayType==='current-token' && displayInfo && displayList && <DisplayCurrentToken displayList={displayList}  displayInfo={displayInfo} /> }
            {displayType==='mini-display' && displayInfo  && <MiniDisplay announceToken={announceTokenId}  displayInfo={displayInfo} /> }
            {displayType==='dual-display' && displayInfo  && <DualCounterDisplay announceToken={announceTokenId}  displayInfo={displayInfo} /> }
            {displayType==='multiple-display' && displayInfo  && <MultipleDisplay announceToken={announceTokenId}  displayInfo={displayInfo} /> }
            {displayType==='video-ads' && displayInfo && <DisplayVideoAdsOnly  displayInfo={displayInfo} /> }
            {displayType==='banner-ads' && displayInfo && <DisplayBannersAdsAndNews  displayInfo={displayInfo} /> }
        </>
        
    )
}

export default DisplayPage